import type { RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

// Projects (Asana / ConnectWise Projects). Owned by the projects module.
export const routes: RouteObject[] = [
  { path: 'projects', lazy: page(() => import('./projects-page'), (m) => m.ProjectsPage) },
  { path: 'projects/my-tasks', lazy: page(() => import('./my-tasks-page'), (m) => m.MyTasksPage) },
  { path: 'projects/workload', lazy: page(() => import('./workload-page'), (m) => m.WorkloadPage) },
  { path: 'projects/templates', lazy: page(() => import('./templates-page'), (m) => m.TemplatesPage) },
  { path: 'projects/:projectId/:tab?', lazy: page(() => import('./project-detail'), (m) => m.ProjectDetailPage) },
];
export const orgRoutes: RouteObject[] = [{ path: 'projects', lazy: page(() => import('./org-projects'), (m) => m.OrgProjectsPage) }];
